import React, { useState } from "react";

import { Board } from "./Board";
import { ResetButton } from "./ResetButton";
import { ScoreBoard } from "./ScoreBoard";
import "./TicTacToe.css";
import styles from "../../template-parts/TemplateParts.module.scss";
import BackButton from "../../template-parts/Backbutton";
import toast from "react-hot-toast";

const TicTacToe = () => {
  const WIN_CONDITIONS = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ];

  const [xPlaying, setXPlaying] = useState(true);
  const [board, setBoard] = useState(Array(9).fill(null));
  const [scores, setScores] = useState({ xScore: 0, oScore: 0 });
  const [gameOver, setGameOver] = useState(false);

  const handleBoxClick = (boxIdx) => {
    // Step 1: Update the board
    const updatedBoard = board.map((value, idx) => {
      if (idx === boxIdx) {
        return xPlaying ? "X" : "O";
      } else {
        return value;
      }
    });

    setBoard(updatedBoard);

    // Step 2: Check if either player has won the game
    const winner = checkWinner(updatedBoard);

    if (winner) {
      if (winner === "O") {
        let { oScore } = scores;
        oScore += 1;
        setScores({ ...scores, oScore });
        toast.success("O Wins")
      } else {
        let { xScore } = scores;
        xScore += 1;
        setScores({ ...scores, xScore });
        toast.success("X Wins")
      }
      setGameOver(true);
      setTimeout(() => {
        resetBoard();
      }, 1000); // wait for 1seconds before resetting the board
      return;
    }

    // Step 3: Check if board is completely filled with no winner
    let boardFilled = true;
    for (let i = 0; i < updatedBoard.length; i++) {
      if (updatedBoard[i] === null) {
        boardFilled = false;
        break;
      }
    }

    if (boardFilled) {
      setGameOver(true);
      toast.error("Sorry! No winner")
      setTimeout(() => {
        resetBoard();
      }, 1000); // wait for 1 seconds before resetting the board
      return;
    }

    // Step 4: Change active player
    setXPlaying(!xPlaying);
  };

  const checkWinner = (board) => {
    for (let i = 0; i < WIN_CONDITIONS.length; i++) {
      const [x, y, z] = WIN_CONDITIONS[i];

      // Iterate through win conditions and check if either player satisfies them
      if (board[x] && board[x] === board[y] && board[y] === board[z]) {
        setGameOver(true);
        return board[x];
      }
    }
  };

  const resetBoard = () => {
    setGameOver(false);
    setBoard(Array(9).fill(null));
  };

  return (
    <div className="mainCont">
      <div className={`${styles.backButtonContainer}`}>
        <BackButton />
      </div>
      <ScoreBoard scores={scores} xPlaying={xPlaying} />
      <Board board={board} onClick={gameOver ? resetBoard : handleBoxClick} />
      <ResetButton resetBoard={resetBoard} />
    </div>
  );
};

export default TicTacToe;
